import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Light from "./images/light.svg";

const PostInspectionDiyContextBanner = ({
    showContextScreen = () => {},
    heading = "How it works?",
    subHeading = "Tap to watch now"
}) => {

    return (
        <div styleName={"styles.videoLink"} onClick={showContextScreen}>
            <div>
                <p>{heading}</p>
                <span>{subHeading}</span>
            </div>
            <img src={Light} alt="tap"/>
        </div>
    );
};

PostInspectionDiyContextBanner.propTypes = {
    showContextScreen: PropTypes.func,
    heading: PropTypes.string,
    subHeading: PropTypes.string
};

export default PostInspectionDiyContextBanner;
